<div>
  <div class="nav-container-1">
    <form [formGroup]="searchForm">
      <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <EIPAutoComplete TextField="projCodeDesc" ValueField="projectId" WaterMarkText="Project"
            formControlName="ctrlProject" setId="ddlProject" ShowTextValueField='N' [dataSource]='projectList'
            [defaultValue]="selectedProject" [SingleValueBind]="false" [IsCascading]='true'
            (valueChange)='setSelectedProject($event)'>
          </EIPAutoComplete>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <EIPAutoComplete TextField="memberName" ValueField="memberId" WaterMarkText="Member"
            formControlName="ctrlMember" setId="ddlMember" ShowTextValueField='N' [dataSource]='searchMemberList'
            [defaultValue]="selectedMember" [SingleValueBind]="false" [IsCascading]='true'
            (valueChange)='setSelectedMember($event)'>
          </EIPAutoComplete>
        </div>
        <div>
          <button style="margin-top: 10%;" class="btn btn-primary btn-sm" (click)="getReport()">Search</button>
        </div>
      </div>
    </form>
  </div>

  <div>
    <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
      [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
    </ssrs-reportviewer>
  </div>
</div>